var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mention-container",on:{"click":_vm.toProjectPage}},[_c('a-badge',{attrs:{"count":_vm.redPointNum,"overflow-count":99,"number-style":{ backgroundColor: '#ff4d4f', fontSize: '10px' }}},[_c('div',{staticClass:"content"},[_c('a-icon',{attrs:{"type":"bell"}}),_c('span',{staticClass:"text"},[_vm._v("待办")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }